var map = {
	"./news.de-CH.json": 1439,
	"./news.de-DE.json": 1440,
	"./news.en-CA.json": 1441,
	"./news.en-GB.json": 1442,
	"./news.en-IN.json": 1443,
	"./news.en-ME.json": 1444,
	"./news.en-US.json": 1445,
	"./news.es-EM.json": 1446,
	"./news.es-ES.json": 1447,
	"./news.fr-BE.json": 1448,
	"./news.fr-CA.json": 1449,
	"./news.fr-CH.json": 1450,
	"./news.nl-BE.json": 1451,
	"./news.nl-NL.json": 1452,
	"./news.pl-PL.json": 1453,
	"./news.pt-BR.json": 1454
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1438;